import React, { useContext, useEffect, useState } from "react";
import {
  CircleFadingPlus,
  Ellipsis,
  EllipsisVertical,
  LogOut,
  Plus,
} from "lucide-react";

import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import { CollapseMenuButton } from "./collapse-menu-button";
import { getMenuList } from "../../lib/menu-list";
import { ScrollArea } from "../ui/scroll-area";
import { Navigate, useNavigate } from "react-router";
import { useSidebarToggle } from "../../hooks/use-sidebar-toggle";
import { useStore } from "zustand";
import { useDispatch, useSelector } from "react-redux";
import ChatService from "../../services/chat/chat";
import { toastError } from "../ToastNotification";
import {
  setChatData,
  setConversationId,
  setConversationType,
  setInitial,
  setSubmitted,
} from "../../store/slices/chatSlice";
import { ChatContext } from "../../context/chatContext";

export function Menu({ isOpen }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSubmtted, setIsSubmtted } = useContext(ChatContext);
  const user = useSelector((state) => state?.user?.user);
  const chat = useSelector((state) => state?.chat);
  const [allChats, setAllChats] = useState([]);
  const sidebar = useStore(useSidebarToggle, (state) => state);
  const [hoveredIndex, setHoveredIndex] = useState("");
  const [userType, setUserType] = useState("");
  const [selectedChatId, setSelectedChatId] = useState(null);
  const [chatType, setChatType] = useState("Individual");

  const handleChatType = (type) => {
    dispatch(setConversationType(type));
    setChatType(type);
    // navigate("/home");
  };

  const getAllChats = async () => {
    try {
      const response = await ChatService?.getAllChats();
      const conversations = Array.isArray(response?.data?.data)
        ? response?.data?.data
        : [];

      setAllChats(conversations);

      if (conversations.length > 0) {
        const selectedConversationType =
          chat?.ConversationType === "Organization"
            ? "Organization"
            : "Individual";

        const getConversationTypeLabel = (conversationType = "") => {
          const normalizedType = String(conversationType).toLowerCase();
          if (normalizedType.includes("organization")) {
            return "Organization";
          }
          return "Individual";
        };

        const nextConversation =
          conversations.find(({ _id }) => _id === chat?.conversationId) ||
          conversations.find(
            ({ conversationType }) =>
              getConversationTypeLabel(conversationType) ===
              selectedConversationType
          ) ||
          conversations[0];

        if (nextConversation?._id) {
          setSelectedChatId(nextConversation._id);
          dispatch(setConversationId(nextConversation._id));
        }
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    const userType = user?.users?.userType;
    setUserType(userType);
    getAllChats();
  }, [user]);

  const menuList = getMenuList(allChats);
  console.log("menuList", menuList);

  useEffect(() => {
    if (isSubmtted) {
      getAllChats();
      setIsSubmtted(false);
      dispatch(setChatData(null));
    }
  }, [isSubmtted]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleChat = async (id) => {
    setSelectedChatId(id);
    navigate(`/home?conversationId=${id}`);
    try {
      const response = await ChatService?.getSingleChat(user?.company?._id, id);
      if (response) {
        dispatch(setChatData(response.data.data));
        dispatch(setConversationId(id));
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    }
  };

  const handleClick = (type) => {
    navigate("/home");
    setSelectedChatId(null);
    dispatch(setConversationId(null));
    dispatch(setInitial(true));
    dispatch(setChatData(null));
    dispatch(setConversationType(type));
  };

  const handleIndivisualClick = (type) => {
    navigate("/home");
    setSelectedChatId(null);
    dispatch(setConversationId(null));
    dispatch(setInitial(true));
    dispatch(setChatData(null));
    dispatch(setConversationType(type));
  };

  return (
    <div className="[&>div>div[style]]:!block h-full">
      <nav className={`w-full mt-5 overflow-hidden `}>
        {userType === "Organization" && (
          <div className="flex gap-4 bg-lightGray rounded-md p-1">
            <Button
              onClick={() => handleChatType("Individual")}
              className={`w-full text-white ${
                chatType === "Individual"
                  ? "bg-body hover:bg-body"
                  : "bg-lightGray hover:bg-lightGray text-white/50"
              }`}
            >
              Individual
            </Button>
            <Button
              onClick={() => handleChatType("Organization")}
              className={`w-full text-white ${
                chatType === "Organization"
                  ? "bg-body hover:bg-body"
                  : "bg-lightGray hover:bg-lightGray text-white/50"
              }`}
            >
              Organization
            </Button>
          </div>
        )}

        <ul className="flex flex-col items-start space-y-1 px-2">
          <div
            className={cn(
              "p-2 sticky top-0 w-full z-50 ",
              sidebar?.isOpen === false ? "" : ""
            )}
          >
            {/* {userType === "Individual" && ( */}
              <div>
                <p className="text-sm font-medium text-muted-foreground px-4 pb-2 max-w-[248px] truncate uppercase">
                  {userType}
                </p>
                <div className="mb-2">
                  <Button
                    className="w-full flex gap-2 bg-primary hover:bg-btnHover text-white text-base"
                    onClick={() => handleIndivisualClick("Individual")}
                  >
                    <CircleFadingPlus className="h-5 w-5" /> New Chat
                  </Button>
                </div>
                <div className="overflow-y-auto h-[calc(100vh-195px)] custom-scroll">
                  {menuList?.map(({ type, menus }, index) => (
                    <div className="cursor-pointer">
                      {(type === "Individual" || type === "Organization") && (
                        <li
                          className={cn("w-full mt-0", type ? "pt-2" : "")}
                          key={index}
                        >
                          <div className="overflow-hidden">
                            <div className="overflow-y-auto custom-scroll">
                              {menus?.map(
                                (
                                  { href, label, active, submenus, _id },
                                  index
                                ) =>
                                  submenus?.length === 0 ? (
                                    <div className="w-full" key={index}>
                                      <TooltipProvider disableHoverableContent>
                                        <Tooltip delayDuration={100}>
                                          <TooltipTrigger asChild>
                                            <Button
                                              variant={
                                                _id == selectedChatId
                                                  ? "thrird"
                                                  : "thrirdHover"
                                              }
                                              className="w-full justify-start h-10 line-clamp-1 text-base cursor-pointer"
                                              asChild
                                              onMouseOver={() =>
                                                setHoveredIndex(index)
                                              }
                                              onMouseOut={() =>
                                                setHoveredIndex("")
                                              }
                                            >
                                              <div
                                                className="flex justify-between items-center"
                                                onClick={() => handleChat(_id)}
                                              >
                                                <p
                                                  className={cn(
                                                    "max-w-[220px] truncate",
                                                    isOpen === false
                                                      ? "-translate-x-96 opacity-0"
                                                      : "translate-x-0 opacity-100"
                                                  )}
                                                >
                                                  {label}
                                                </p>
                                                <span className={`text-white`}>
                                                  {/* {hoveredIndex === index ? (
                                                  <EllipsisVertical />
                                                ) : (
                                                  ""
                                                )} */}
                                                </span>
                                              </div>
                                            </Button>
                                          </TooltipTrigger>
                                          {isOpen === false && (
                                            <TooltipContent side="right">
                                              {label}
                                            </TooltipContent>
                                          )}
                                        </Tooltip>
                                      </TooltipProvider>
                                    </div>
                                  ) : (
                                    <div className="w-full" key={index}>
                                      <CollapseMenuButton
                                        label={label}
                                        active={active}
                                        submenus={submenus}
                                        isOpen={isOpen}
                                      />
                                    </div>
                                  )
                              )}
                            </div>
                          </div>
                        </li>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            {/* )} */}
            {userType === "Organization" && (
              <div className="">
                {chatType === "Organization" && (
                  <div className="pb-5">
                    {/* <p className="text-sm font-medium text-muted-foreground px-4 pb-2 max-w-[248px] truncate uppercase">
                      {userType}
                    </p> */}
                    <div className="mb-2">
                      <Button
                        className="w-full flex gap-2 bg-primary hover:bg-btnHover text-white text-base"
                        onClick={() => handleClick("Organization")}
                      >
                        <CircleFadingPlus className="h-5 w-5" /> New Chat
                      </Button>
                    </div>
                    <div className="overflow-hidden">
                      <div className="overflow-y-auto h-[calc(100vh-230px)] custom-scroll">
                        {menuList?.map(({ type, menus }, index) => (
                          <>
                            {type === "Organization" && (
                              <li
                                className={cn(
                                  "w-full mt-0",
                                  type ? "pt-2" : ""
                                )}
                                key={index}
                              >
                                <div className="overflow-hidden">
                                  <div className="overflow-y-auto custom-scroll">
                                    {menus?.map(
                                      (
                                        { href, label, active, submenus, _id },
                                        index
                                      ) =>
                                        submenus?.length === 0 ? (
                                          <div className="w-full" key={index}>
                                            <TooltipProvider
                                              disableHoverableContent
                                            >
                                              <Tooltip delayDuration={100}>
                                                <TooltipTrigger asChild>
                                                  <Button
                                                    variant={
                                                      _id == selectedChatId
                                                        ? "thrird"
                                                        : "thrirdHover"
                                                    }
                                                    className="w-full justify-start h-10 line-clamp-1 text-base cursor-pointer"
                                                    asChild
                                                    onMouseOver={() =>
                                                      setHoveredIndex(index)
                                                    }
                                                    onMouseOut={() =>
                                                      setHoveredIndex("")
                                                    }
                                                  >
                                                    <div
                                                      className="flex justify-between items-center"
                                                      onClick={() =>
                                                        handleChat(_id)
                                                      }
                                                    >
                                                      <p
                                                        className={cn(
                                                          "max-w-[220px] truncate",
                                                          isOpen === false
                                                            ? "-translate-x-96 opacity-0"
                                                            : "translate-x-0 opacity-100"
                                                        )}
                                                      >
                                                        {label}
                                                      </p>
                                                      <span
                                                        className={`text-white`}
                                                      >
                                                        {/* {hoveredIndex ===
                                                      index ? (
                                                        <Ellipsis />
                                                      ) : (
                                                        ""
                                                      )} */}
                                                      </span>
                                                    </div>
                                                  </Button>
                                                </TooltipTrigger>
                                                {isOpen === false && (
                                                  <TooltipContent side="right">
                                                    {label}
                                                  </TooltipContent>
                                                )}
                                              </Tooltip>
                                            </TooltipProvider>
                                          </div>
                                        ) : (
                                          <div className="w-full" key={index}>
                                            <CollapseMenuButton
                                              label={label}
                                              active={active}
                                              submenus={submenus}
                                              isOpen={isOpen}
                                            />
                                          </div>
                                        )
                                    )}
                                  </div>
                                </div>
                              </li>
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {chatType === "Individual" && (
                  <div className="">
                    {/* <p className="text-sm font-medium text-muted-foreground px-4 pb-2 max-w-[248px] truncate uppercase">
                      Individual
                    </p> */}
                    <div className="mb-2">
                      <Button
                        className="w-full flex gap-2 bg-primary hover:bg-btnHover text-white text-base"
                        onClick={() => handleIndivisualClick("Individual")}
                      >
                        <CircleFadingPlus className="h-5 w-5" /> New Chat
                      </Button>
                    </div>
                    <div className="overflow-hidden">
                      <div className="overflow-y-auto h-[calc(100vh-220px)] custom-scroll">
                        {menuList?.map(({ type, menus }, index) => (
                          <>
                            {type === "Individual" && (
                              <li
                                className={cn(
                                  "w-full mt-0",
                                  type ? "pt-2" : ""
                                )}
                                key={index}
                              >
                                <div className="overflow-hidden">
                                  <div className="overflow-y-auto custom-scroll">
                                    {menus?.map(
                                      (
                                        { href, label, active, submenus, _id },
                                        index
                                      ) =>
                                        submenus?.length === 0 ? (
                                          <div className="w-full" key={index}>
                                            <TooltipProvider
                                              disableHoverableContent
                                            >
                                              <Tooltip delayDuration={100}>
                                                <TooltipTrigger asChild>
                                                  <Button
                                                    variant={
                                                      _id == selectedChatId
                                                        ? "thrird"
                                                        : "thrirdHover"
                                                    }
                                                    className="w-full justify-start h-10 line-clamp-1 text-base cursor-pointer"
                                                    asChild
                                                    onMouseOver={() =>
                                                      setHoveredIndex(index)
                                                    }
                                                    onMouseOut={() =>
                                                      setHoveredIndex("")
                                                    }
                                                  >
                                                    <div
                                                      className="flex justify-between items-center"
                                                      onClick={() =>
                                                        handleChat(_id)
                                                      }
                                                    >
                                                      <p
                                                        className={cn(
                                                          "max-w-[220px] truncate",
                                                          isOpen === false
                                                            ? "-translate-x-96 opacity-0"
                                                            : "translate-x-0 opacity-100"
                                                        )}
                                                      >
                                                        {label}
                                                      </p>
                                                      <span
                                                        className={`text-white`}
                                                      >
                                                        {/*  {hoveredIndex ===
                                                      index ? (
                                                        <EllipsisVertical />
                                                      ) : (
                                                        ""
                                                      )} */}
                                                      </span>
                                                    </div>
                                                  </Button>
                                                </TooltipTrigger>
                                                {isOpen === false && (
                                                  <TooltipContent side="right">
                                                    {label}
                                                  </TooltipContent>
                                                )}
                                              </Tooltip>
                                            </TooltipProvider>
                                          </div>
                                        ) : (
                                          <div className="w-full" key={index}>
                                            <CollapseMenuButton
                                              label={label}
                                              active={active}
                                              submenus={submenus}
                                              isOpen={isOpen}
                                            />
                                          </div>
                                        )
                                    )}
                                  </div>
                                </div>
                              </li>
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </ul>
      </nav>
    </div>
  );
}
